export default {
  insertUrl: 'Inserta el enlace aquí',
  urlSubmit: 'Subir',
  linkError: 'Debes insertar una URL válida',
  uploadingFile: 'Subiendo archivo...',
  cancel: 'Cancelar',
  extensionError: 'Debes subir un archivo válido',
  image: {
    header: 'Subir una imagen',
    selectFile: 'Selecciona una imagen para subir',
    dropFile: 'o arrastra y suelta la imagen aquí',
    url: 'O sube una imagen desde un enlace'
  },
  pdf: {
    header: 'Subir archivo PDF',
    selectFile: 'Selecciona un archivo PDF para subir',
    dropFile: 'o arrastra y suelta el archivo aquí',
    url: 'O sube un archivo PDF desde una URL'
  },
  video: {
    header: 'Subir un video',
    selectFile: 'Selecciona un video para subir',
    dropFile: 'o arrastra y suelta el video aquí',
    url: 'O sube un vídeo desde un enlace'
  }
}

export const en = {
  insertUrl: 'Insert link here',
  urlSubmit: 'Upload',
  linkError: 'Enter a valid URL',
  uploadingFile: 'Uploading file...',
  cancel: 'Cancel',
  extensionError: 'Upload a valid file',
  image: {
    header: 'Upload an image',
    selectFile: 'Select an image to upload',
    dropFile: 'or drag and drop the image here',
    url: 'Or upload a picture from a link'
  },
  pdf: {
    header: 'Upload PDF file',
    selectFile: 'Select a PDF file to upload',
    dropFile: 'or drag and drop the file here',
    url: 'Or upload a PDF file from a URL'
  },
  video: {
    header: 'Upload video',
    selectFile: 'Select video to upload',
    dropFile: 'or drag and drop the video here',
    url: 'Or upload a video from a link'
  }
}

export const ca = {
  insertUrl: 'Insereix un enllaç aquí',
  urlSubmit: 'Carregar',
  linkError: 'Has d\'inserir una URL vàlida',
  uploadingFile: 'Carregant arxiu...',
  cancel: 'Cancel·lar',
  extensionError: 'Has de carregar un arxiu vàlid',
  image: {
    header: 'Carregar una imatge',
    selectFile: 'Selecciona una imatge per carregar',
    dropFile: 'o arrossega i solta la imatge aquí',
    url: 'O carrega una imatge des d\'un enllaç'
  },
  pdf: {
    header: 'Carrega arxiu PDF',
    selectFile: 'Selecciona un arxiu PDF per carregar',
    dropFile: 'o arrossega i solta l\'arxiu aquí',
    url: 'O carrega un arxiu PDF des d\'una URL'
  },
  video: {
    header: 'Carrega un vídeo',
    selectFile: 'Selecciona un vídeo per carregar',
    dropFile: 'o arrossega i solta el vídeo aquí',
    url: 'O carrega un vídeo des d\'un enllaç'
  }
}
